import React from 'react';
import { Container, Box, Button, Typography } from '@mui/material';
import useStore from 'src/store/cns';
import { useNavigate } from 'react-router-dom';
import { handleError } from 'src/utils/errors/common';
import { getDomainTree } from 'src/utils/logs/domain';
import { getApprovedTokens } from 'src/utils/logs/token';
import { connectMetaMask } from 'src/utils/wallet';

const Wallet = () => {
  const login = useStore(state => state.login);
  const setTokens = useStore(state => state.setTokens);

  const handleLogin = async () => {
    try {
      const signer = await connectMetaMask();
      const tree = await getDomainTree();
      login(signer, tree);

      setTokens(await getApprovedTokens());

      navigate('/cns');
    } catch (error) {
      handleError(
        error,
        'Failed to connect wallet. Make sure MetaMask is installed and on Base Sepolia.',
      );
    }
  };

  const navigate = useNavigate();

  return (
    <Container
      maxWidth="xs"
      sx={{
        mt: 8,
        border: '1px solid',
        borderColor: 'rgba(145, 158, 171, 0.24)',
        borderRadius: '16px',
        padding: '2rem',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Connect Wallet
        </Typography>
        <Button
          data-cy="login-button"
          variant="contained"
          color="primary"
          onClick={handleLogin}
          sx={{
            color: 'text.primary',
            backgroundColor: 'primary.main',
            padding: '10px 16px',
            mt: 2,
          }}
        >
          Connect MetaMask
        </Button>

        <Typography variant="subtitle2" sx={{ mt: 2 }} gutterBottom>
          Hint: The app runs on Base Sepolia — MetaMask will be switched
          automatically.
        </Typography>
      </Box>
    </Container>
  );
};

export default Wallet;
